module.exports = __webpack_public_path__ + "img/module1.2e40f28.png";